import React from 'react';
import { useImpersonation } from '@/core/auth/ImpersonationContext';
import { Button } from '@/components/ui';

export function ImpersonationBanner() {
  const { isImpersonating, impersonatedUser, stopImpersonation } = useImpersonation();

  if (!isImpersonating || !impersonatedUser) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[9999] bg-gradient-to-r from-amber-600 via-orange-500 to-amber-600 text-white px-6 py-2.5 flex items-center justify-between backdrop-blur-md border-b border-white/10 animate-in slide-in-from-top duration-500 ease-out">
      {/* Decorative background element */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-1/2 -left-1/4 w-1/2 h-[200%] bg-white/10 rotate-12 blur-3xl animate-pulse" />
      </div>

      <div className="flex items-center gap-4 relative z-10">
        <div className="w-10 h-10 rounded-md bg-white/20 backdrop-blur-xl flex items-center justify-center border border-white/30 shadow-inner group transition-all duration-300 hover:scale-105">
          <i className="ri-user-shared-2-line text-2xl animate-pulse" />
        </div>
        <div className="flex flex-col">
          <div className="flex items-center gap-2">
            <span className="text-xs tracking-[0.2em] text-amber-100/80">Security Mode</span>
            <span className="w-1 h-1 rounded-full bg-white/40" />
            <p className="text-xs tracking-[0.1em] text-white/90">Chế độ Nhập vai</p>
          </div>
          <p className="sm:text-sm text-xs leading-tight flex items-center gap-1.5">
            Đang đại diện cho:
            <span className="text-white underline decoration-white/40 decoration-2 underline-offset-4">
              {impersonatedUser.full_name}
            </span>
            <span className="text-white/60 font-mono text-xs ml-1">({impersonatedUser.role_code})</span>
          </p>
        </div>
      </div>

      <div className="flex items-center gap-4 relative z-10">
        <div className="hidden lg:flex items-center gap-2 px-3 py-1.5 rounded-md bg-black/10 border border-white/5 text-xs text-amber-50">
          <i className="ri-shield-check-line text-amber-300" />
          <span>Phiên làm việc được giám sát & ghi nhật ký</span>
        </div>

        <Button
          variant="secondary"
          size="sm"
          onClick={stopImpersonation}
          className="h-10 px-5 bg-white text-orange-600 hover:bg-amber-50 border-none text-xs tracking-wider transition-all duration-300 active:scale-95 flex items-center gap-2"
        >
          <i className="ri-logout-circle-r-line" />
          Dừng Nhập vai
        </Button>
      </div>
    </div>
  );
}
